import { CompanyDetailPageComponent } from "@agent-ds/company/pages";
import { JobDetailPageComponent } from "@agent-ds/jobs/pages/job-detail-page/job-detail-page.component";
import {
  ProgressCreateDialogComponent,
  ProgressScheduleAdjustDialogComponent,
  ProgressScreeningRequestNotifyDialogComponent,
  ProgressSubScreeningRequestNotifyDialogComponent,
  ProgressSubScreeningScheduleAdjustDialogComponent,
  ProgressSubScreeningStartDialogComponent
} from "@agent-ds/progress/components";
// tslint:disable-next-line:max-line-length
import { BulkProgressChangeDialogConfig } from "@agent-ds/shared/components/bulk-progress-change-dialog/bulk-progress-change-dialog-interface";
// tslint:disable-next-line:max-line-length
import { BulkProgressChangeDialogComponent } from "@agent-ds/shared/components/bulk-progress-change-dialog/bulk-progress-change-dialog.component";
import { PageScrollTableComponent } from "@agent-ds/shared/components/page-scroll-table/page-scroll-table.component";
import {
  BatchResult,
  TableConfig
} from "@agent-ds/shared/components/page-scroll-table/table-interface";
import {
  getProgressStatusLabel,
  getSeminarTypeLabel,
  NULL_SELECTED_VALUE,
  PROGRESS_ACTION_CODES,
  PROGRESS_BULK_EDIT,
  PROGRESS_STATUSES,
  RESUME_REQUIRED_ON_RECOMMEND_VALUE,
  SEMINAR_TYPE
} from "@agent-ds/shared/constants";
import {
  PROGRESS_SUB_SCREENING_STATUS_CODE_LABEL_MAPPING,
  ProgressActionColor,
  ProgressActionType,
  ProgressScreeningRequestStatusRequestNoEnum,
  ProgressScreeningRequestStatusRequestStatusEnum,
  ProgressStatusCode,
  ProgressSubScreeningStatusCodes,
} from "@agent-ds/shared/enums";
import {
  EnterpriseDepartmentUserType,
  Job,
  JobSettingSeminarSchedule,
  JobUserCheckResponse,
  MailTemplateResponse,
  Progress,
  ProgressAction,
  ProgressBulkEditAction,
  ProgressBulkEditRequest,
  ProgressHistoryRemarksUpdateRequest,
  ProgressItemJobUserResponse,
  ProgressItemResponse,
  ProgressSubScreeningStatus,
  ProgressSearchParams,
  ProgressSearchResponse,
  ProgressStakeholderEmailResponse,
  ProgressUpdateWithActionRequest,
  StudentDetail,
  Team,
  User,
  SCREENING_INFO_REQUEST_DEADLINE_OPTIONS,
  ProgressScreeningRequestStatus,
  ProgressSubScreeningStatusUpdateWithActionRequest,
  JobScreeningInfo
} from "@agent-ds/shared/interfaces";
import { CacheInterceptor } from "@agent-ds/shared/interceptors/cache.interceptor";
import {
  DetailPage,
  FormMeta,
  RefreshEvent,
  RowMeta
} from "@agent-ds/shared/models";
import { SafeDatePipe } from "@agent-ds/shared/pipes/safe-date.pipe";
import {
  AuthService,
  CustomerExpectedCompanyYomiService,
  DialogService,
  DynamicFieldService,
  JobApiService,
  MailApiService,
  StudentApiService
} from "@agent-ds/shared/services";
import { MasterApiService } from "@agent-ds/shared/services/api/master-api.service";
import { ProgressApiService } from "@agent-ds/shared/services/api/progress-api.service";
import { UserApiService } from "@agent-ds/shared/services/api/user-api.service";
import {
  cleanObject,
  deepClone,
  formatTemplateMultilineValue,
  getValueFromObject
} from "@agent-ds/shared/util/util";
import { StudentDetailPageComponent } from "@agent-ds/student/pages";
import { Location } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  Type,
  ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import {
  EMPTY,
  forkJoin,
  Observable,
  of,
  Subscription,
  SubscriptionLike
} from "rxjs";
import { catchError, concatMap, map, mergeMap, tap } from "rxjs/operators";
import { ProgressDetailComponent } from "../../../progress/pages/progress-detail/progress-detail.component";
import { ConfirmDialogConfig } from "../confirm-dialog/confirm-dialog-config";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { DialogRef } from "../dialog/dialog-ref";
import { MailSendFlowComponent } from "../mail-send-flow/mail-send-flow.component";
import { MailSendConfig } from "../mail-send/config";
import { ProgressBulkConfig } from "../mail-send/configs/progress-bulk-config";
import { ProgressConsultConfig } from "../mail-send/configs/progress-consult-config";
import { ProgressInrowJobPostingConfig } from "../mail-send/configs/progress-inrow-job-posting-config";
import { ProgressJobPostingConfig } from "../mail-send/configs/progress-job-posting-config";
import { ProgressNgEndConfig } from "../mail-send/configs/progress-ng-end-config";
import { ProgressOfferConfig } from "../mail-send/configs/progress-offer-config";
import { ProgressRecommendConfig } from "../mail-send/configs/progress-recommend-config";
import { ProgressSendInterviewInfoConfig } from "../mail-send/configs/progress-send-interview-info-config";
import { ProgressSendResumeConfig } from "../mail-send/configs/progress-send-resume-config";
import { PopupControlComponent } from "../popup-control/popup-control.component";
import { ProgressSeminarScheduleLinkDialogComponent } from "../progress-seminar-schedule-link-dialog/progress-seminar-schedule-link-dialog.component";
import { ProgressSeminarScheduleLinkDialogResult } from "../progress-seminar-schedule-link-dialog/progress-seminar-schedule-link-dialog-interface";
import { SelectComponent } from "../select/select.component";
import { PROGRESS_LIST_TABLE_CONFIG } from "./progress-list-table-config";
import { ProgressSendSubScreeningInfoConfig } from "../mail-send/configs/progress-send-sub-screening-info-config";
import * as moment from "moment";
import * as _ from "underscore";

interface SubStatusAction {
  label: string;
  withBorderRight?: boolean;
  btnColor?: 'green'|'gray'|'substatus'|'red'|'blue';
  onClick: (param: any) => void;
}
@Component({
  selector: "ag-progress-list",
  templateUrl: "./progress-list.component.html",
  styleUrls: ["./progress-list.component.scss"]
})
export class ProgressListComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild(PageScrollTableComponent, { static: false })
  table: PageScrollTableComponent;
  @ViewChild(SelectComponent, { static: false })
  progressStatusSelect: SelectComponent;
  @ViewChild("status", { static: false }) statusTemplate: TemplateRef<any>;
  @ViewChild("applicant", { static: false }) applicantTemplate: TemplateRef<
    any
  >;
  @ViewChild("applicantContact", { static: false })
  applicantContactTemplate: TemplateRef<any>;
  @ViewChild("jobGeneral", { static: false }) jobTemplate: TemplateRef<any>;
  @ViewChild("jobContact", { static: false }) jobContactTemplate: TemplateRef<
    any
  >;
  @ViewChild("cellArrow", { static: true }) cellArrowTemplate: TemplateRef<any>;
  @ViewChild("actions", { static: false }) actionsTemplate: TemplateRef<any>;
  @ViewChild("raExpectedContractMonthSection", { static: false }) raExpectedContractMonthSectionTemplate: TemplateRef<any>;
  @ViewChild("missingInfoDialog", { static: false })
  missingInfoDialogTemplate: TemplateRef<any>;

  @Input() requestObject: ProgressSearchParams = { status: [] };
  @Input() disableDetailFullScreen = false;
  @Input() disableBulkUpdateButton = false;
  @Input() enableSeminarScheduleLinkButton = false;
  @Input() student: StudentDetail;
  @Input() job: Job;
  @Output() statusFilterChange = new EventEmitter<number[]>();
  @Output() errorGetList = new EventEmitter<HttpErrorResponse>();

  progresses: ProgressItemResponse[];
  tableConfig: TableConfig;
  initialized = false;
  ProgressActionType = ProgressActionType;
  ProgressActionColor = ProgressActionColor;
  ProgressStatusCode = ProgressStatusCode;
  getStatusLabel = getProgressStatusLabel;
  offerConfig = new ProgressOfferConfig();
  consultConfig = new ProgressConsultConfig();
  bulkConfig = new ProgressBulkConfig();
  recommendConfig = new ProgressRecommendConfig();
  ngEndConfig = new ProgressNgEndConfig();
  ProgressSendInterviewInfoConfig = ProgressSendInterviewInfoConfig;
  ProgressSendSubScreeningInfoConfig = ProgressSendSubScreeningInfoConfig;

  readonly PROGRESS_STATUSES = PROGRESS_STATUSES;
  canBulkEdit = false;
  canSeminarScheduleLink = false;
  progressTypeSelectOptions = [
    { label: NULL_SELECTED_VALUE, value: undefined },
    { label: "AG", value: 0 },
    { label: "Plus", value: 1 }
  ];
  progressStatusCodesSelectOptions = Object.keys(PROGRESS_STATUSES)
    .filter(code => +code !== 210 && +code < 500)
    .map(statusCode => {
      const code = +statusCode;
      if (code === 100) {
        return [
          { label: "1次面接設定中", value: 503 },
          { label: "2次以降面接設定中", value: 506 }
          // { label: '最終前面接設定中', value: 510 },
          // { label: '最終面接設定中', value: 520 },
        ];
      } else if (code === 110) {
        return [
          { label: "1次面接確認中", value: 504 },
          { label: "2次以降面接確認中", value: 507 },
          { label: "最終前面接確認中", value: 511 },
          { label: "最終面接確認中", value: 521 }
        ];
      } else if (code === 120) {
        return [
          { label: "1次面接結果待ち", value: 505 },
          { label: "2次以降面接結果待ち", value: 508 },
          { label: "最終前面接結果待ち", value: 512 },
          { label: "最終面接結果待ち", value: 522 }
        ];
      }
      return {
        label: PROGRESS_STATUSES[statusCode].label,
        value: code
      };
    })
    .flatten();
  eventEditors: {
    [progressId: number]: {
      seminarAt: any;
      seminarType: null | 99 | 100 | 1;
      seminarAtMailSendFlag: boolean;
      requestObject: ProgressUpdateWithActionRequest;
      inSave: boolean;
    };
  } = {};
  subStatusEventEditors: {
    [progressSubScreeningStatusId: number]: {
      scheduledAt: any;
      skipSendScheduledAtMail: boolean;
      inSave: boolean;
    };
  } = {};
  remarkEditors: {
    [progressId: number]: {
      remarks: string;
      edit: boolean;
      show: boolean;
    };
  } = {};
  stopReasonEditors: {
    [progressId: number]: {
      stopReason: string;
      edit: boolean;
      show: boolean;
    };
  } = {};
  readonly editorMeta: { [key: number]: FormMeta } = {};
  readonly subStatusEditorMeta: { [key: number]: FormMeta } = {};
  baseEditorMeta: FormMeta;
  baseSubStatusEditorMeta: FormMeta;
  dateTime: RowMeta;

  ckeckJobUsersInProgress = false;
  jobUserChecks: JobUserCheckResponse[] | null = null;

  private dialogRef: DialogRef;
  private refreshSubscription: Subscription;
  private itemCheckedSubscription: Subscription;
  public alertDropdownStates: { [key: string]: boolean } = {};

  public get hasCheckedItems() {
    return this.table && this.table.hasCheckedItems;
  }

  constructor(
    private masterApiService: MasterApiService,
    private userApiService: UserApiService,
    private progressApiService: ProgressApiService,
    private jobApiService: JobApiService,
    public readonly datePipe: SafeDatePipe,
    private cdr: ChangeDetectorRef,
    private dialog: DialogService,
    private location: Location,
    private dynamicService: DynamicFieldService,
    private studentApiService: StudentApiService,
    private mailApiService: MailApiService,
    private authService: AuthService,
    private router: Router,
    private expectedCompanyYomiService: CustomerExpectedCompanyYomiService,
  ) {}

  ngOnInit() {
    this.refreshSubscription = this.progressApiService.refreshEvent.subscribe(
      () => this.refreshData(true, true)
    );
    this.checkRoute();
    this.dateTime = this.dynamicService.getFormRows({
      fieldType: "date",
      fieldName: "seminarAt",
      displayType: "date+time"
    })[0];
    this.dateTime.fields.push({
      type: "radio",
      name: "seminarType",
      labelField: "label",
      valueField: "value",
      options: [
        { label: NULL_SELECTED_VALUE, value: 1 },
        { label: "最終前面接", value: 99 },
        { label: "最終面接", value: 100 }
      ]
    });
    this.baseEditorMeta = {
      groups: [
        {
          class: "no-title-column no-border no-background",
          rows: [this.dateTime]
        }
      ]
    };
    const subStatusDateFormRow: RowMeta = this.dynamicService.getFormRows({
      fieldType: "date",
      fieldName: "scheduledAt",
      displayType: "date+time"
    })[0];
    this.baseSubStatusEditorMeta = {
      groups: [
        {
          class: "no-title-column no-border no-background",
          rows: [
            subStatusDateFormRow
          ]
        }
      ]
    };
  }

  ngOnChanges(changes?: SimpleChanges) {
    if (
      changes &&
      changes["student"] != null &&
      changes["student"].previousValue !== changes["student"].currentValue &&
      this.progressStatusSelect
    ) {
      this.progressStatusSelect.selectAll();
    }
    if (
      !changes ||
      (changes["requestObject"] &&
        changes["requestObject"].previousValue !==
          changes["requestObject"].currentValue)
    ) {
      [...Object.keys(this.eventEditors), ...Object.keys(this.remarkEditors)]
        .removeSame()
        .forEach(key => this.onCancelClick(+key));
      if (this.table && this.initialized) {
        this.refreshData();
      }
    }
  }

  ngAfterViewInit() {
    this.tableConfig = PROGRESS_LIST_TABLE_CONFIG(
      this.statusTemplate,
      this.applicantTemplate,
      this.applicantContactTemplate,
      this.cellArrowTemplate,
      this.jobTemplate,
      this.jobContactTemplate,
      this.actionsTemplate,
      this.raExpectedContractMonthSectionTemplate,
      date => this.datePipe.transform(date, "yyyy/MM/dd (E) HH:mm")
    );

    this.cdr.detectChanges();
    this.initialized = true;
    if (this.requestObject && this.table) {
      this.refreshData(true);
    }
    if (this.table) {
      this.itemCheckedSubscription = this.table.itemChecked.subscribe(() => {
        this.computeCanBulkEdit();
        this.computeCanSeminarScheduleLink();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    if (this.itemCheckedSubscription) {
      this.itemCheckedSubscription.unsubscribe();
    }
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  public showStudentDelayBtn(status: ProgressStatusCode): boolean {
    return status === 70 || status === 90 || status === 100;
  }

  public showSeminarDate(status: ProgressStatusCode): boolean {
    return status === 80 || status === 90 || status === 110 || status === 120;
  }

  public showEnterpriseDocReceivedDate(status: ProgressStatusCode): boolean {
    return status === 60;
  }

  public showOfferedDate(status: ProgressStatusCode): boolean {
    return status === 130 || status === 140;
  }

  public showInvoiceReceivedDate(status: ProgressStatusCode): boolean {
    return status === 150;
  }

  public showInvoiceProcessedDate(status: ProgressStatusCode): boolean {
    return status === 160;
  }

  public getContactUser(userId: number): Observable<User> {
    return userId != null
      ? this.userApiService
          .getAll()
          .pipe(map((users: User[]) => users.find(user => user.id === userId)))
      : of(null);
  }

  public getContactTeamName(userId: number): Observable<string> {
    return this.getContactUser(userId).pipe(
      concatMap((user: User) =>
        user ? this.getTeamNameForUser(user) : of(null)
      )
    );
  }

  public getJobContactUser(
    jobUsers: ProgressItemJobUserResponse[],
    type: 0 | 1
  ): Observable<User> {
    const jobUserType =
      type === 0
        ? EnterpriseDepartmentUserType.RA
        : type === 1
        ? EnterpriseDepartmentUserType.PA
        : null;
    const jobUser =
      jobUsers && jobUsers.length
        ? jobUsers.find(
            user => user.enterpriseDepartmentUser.type === jobUserType
          )
        : null;
    return jobUser &&
      jobUser.enterpriseDepartmentUser &&
      jobUser.enterpriseDepartmentUser.userId != null
      ? this.getContactUser(jobUser.enterpriseDepartmentUser.userId)
      : of(null);
  }

  public getJobContactTeamName(
    jobUsers: ProgressItemJobUserResponse[],
    type: 0 | 1
  ): Observable<string> {
    return this.getJobContactUser(jobUsers, type).pipe(
      concatMap((user: User) =>
        user ? this.getTeamNameForUser(user) : of(null)
      )
    );
  }

  private getTeamNameForUser(user: User): Observable<string> {
    return this.masterApiService.getTeams().pipe(
      map((teams: Team[]) => {
        const foundTeam = teams.find(team => team.id === user.teamId);
        return foundTeam ? foundTeam.name : "";
      })
    );
  }

  public onProgressSelect(progress: ProgressItemResponse): void {
    ProgressDetailComponent.instance.disableFullScreen = this.disableDetailFullScreen;
    ProgressDetailComponent.instance.referenceId = progress
      ? progress.id
      : null;
    ProgressDetailComponent.instance.open();
    this.cdr.detectChanges();
  }

  public onProgressFilterChange() {
    this.statusFilterChange.emit();
    this.refreshData();
  }

  public onStudentDelayClick(
    progress: ProgressItemResponse,
    event: MouseEvent
  ) {
    event.stopPropagation();
    this.progressApiService
      .updateWithoutAction(progress.id, {
        type: progress.type,
        hasInterview: progress.hasInterview,
        n: progress.n,
        seminarType: progress.seminarType,
        isStudentDelay: progress.isStudentDelay > 0 ? 0 : 1,
        seminarAt: progress.seminarAt,
        dynamicData: progress.dynamicData
      })
      .subscribe(() => {
        progress.isStudentDelay = progress.isStudentDelay > 0 ? 0 : 1;
        this.progressApiService.refreshEvent.emit();
      });
  }

  public onProgressActionClick(
    progress: ProgressItemResponse,
    action: ProgressAction
  ): void {
    if (!progress || !action) {
      return;
    }

    // requiresResume が付いたアクション（遷移先に 40 を含むもの）だけがこのチェックを通る。
    // それ以外のアクションは従来どおり素通りして下の switch に進む
    if (action.requiresResume && this.isRecommendBlockedByResume(progress)) {
      this.openResumeRequiredDialog();
      return;
    }

    switch (action.type) {
      case ProgressActionType.DELETE:
        this.onDeleteActionClick(progress.id);
        break;
      case ProgressActionType.DIALOG:
        this.onDialogActionClick(progress, action.dialog, action.id);
        break;
      case ProgressActionType.EDITOR:
        this.onEditorActionClick(
          progress.id,
          action.request ? action.request(progress, action.baseRequest) : null,
          action.seminarValues
        );
        break;
      case ProgressActionType.MAIL:
        this.onMailActionClick(progress, action.mailConfig);
        break;
      case ProgressActionType.OPERATION:
        this.onOperationActionClick(
          progress.id,
          action.request ? action.request(progress, action.baseRequest) : null
        );
        break;
      default:
        return;
    }
  }

  public onMailActionClick(
    progress: ProgressItemResponse,
    mailConfig: any
  ): void {
    if (!mailConfig) {
      return;
    }

    const mailConfigInstance = new mailConfig();

    const progressObj: any = {};
    if (progress) {
      if (this.eventEditors[progress.id]) {
        progressObj.progressSeminarAt =
          new Date(
            this.eventEditors[progress.id].seminarAt
          ).toAsialDateTimeString() || progress.seminarAt;
        progressObj.progressSeminarType = this.eventEditors[
          progress.id
        ].seminarType;
      } else {
        progressObj.progressSeminarAt = progress.seminarAt;
        progressObj.progressSeminarType = progress.seminarType;
      }
      progressObj.progressId = progress.id;
      progressObj.progressN = progress.n;
      progressObj.progressHasInterview = progress.hasInterview;
      progressObj.progressSeminarAtMailSendFlag = 1;
      progressObj.progressIsStudentDelay = progress.isStudentDelay;
      progressObj.progressType = progress.type;
      progressObj.progressStatus = progress.status;
    }

    if (mailConfigInstance instanceof ProgressRecommendConfig) {
      this.openMail(mailConfigInstance, progress, true);
    } else if (
      mailConfigInstance instanceof ProgressInrowJobPostingConfig ||
      mailConfigInstance instanceof ProgressJobPostingConfig
    ) {
      forkJoin(
        this.studentApiService.getSuggestions(undefined, [progress.studentId]),
        this.jobApiService.getSuggestions(undefined, [progress.jobId])
      ).subscribe(([students, jobs]) => {
        MailSendFlowComponent.instance.config = mailConfigInstance;
        mailConfigInstance.setParams({
          students: students,
          jobs: jobs,
          ...progressObj
        });
        MailSendFlowComponent.instance.start();
        const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
          this.refreshData(true, true);
          if (progress && this.eventEditors[progress.id]) {
            this.eventEditors[progress.id] = null;
          }
          sentSub.unsubscribe();
        });
        const closedSub = MailSendFlowComponent.instance.closed.subscribe(
          () => {
            sentSub.unsubscribe();
            closedSub.unsubscribe();
          }
        );
      });
    } else if (mailConfigInstance instanceof ProgressSendInterviewInfoConfig) {
      this.progressApiService
        .getStakeholders([progress.id])
        .subscribe((stakeholders: ProgressStakeholderEmailResponse[]) => {
          if (stakeholders.length) {
            MailSendFlowComponent.instance.config = mailConfigInstance;

            const settingStatus = [
              ProgressStatusCode.セミナー設定中,
              ProgressStatusCode.面接設定中
            ].includes(progress.status);
            const confirmStatus = [
              ProgressStatusCode.セミナー確認中,
              ProgressStatusCode.面接確認中
            ].includes(progress.status);

            const progressUpdateRequest = settingStatus
              ? this.buildSendInterviewInfoUpdateRequest(progress, progressObj)
              : confirmStatus
              ? this.buildConfirmInterviewInfoUpdateRequest(progress, progressObj)
              : null;

            mailConfigInstance.setParams({
              stakeholders: stakeholders[0],
              progressType: progress.type,
              studentId: progress.studentId,
              jobId: progress.jobId,
              enterpriseId: progress.enterprise.id,
              progressUpdateRequest,
              ...progressObj
            });

            MailSendFlowComponent.instance.start();

            if (settingStatus || confirmStatus) {
              const sub = MailSendFlowComponent.instance.sent.subscribe(() => {
                this.progressApiService.refreshEvent.emit();
                if (progress && this.eventEditors[progress.id]) {
                  this.eventEditors[progress.id] = null;
                }
                sub.unsubscribe();
              });
              const closedSub = MailSendFlowComponent.instance.closed.subscribe(
                () => {
                  sub.unsubscribe();
                  closedSub.unsubscribe();
                }
              );
            }
          }
        });
    } else if (mailConfigInstance instanceof ProgressSendResumeConfig) {
      if (this.authService.authInfo.zone !== "zone3") {
        PopupControlComponent.instance.open({
          title: null,
          content: "ZONE3専用です。",
          confirmText: "OK",
          confirmCallback: () => false
        });
        return;
      }
      forkJoin(
        this.studentApiService.getSuggestions(undefined, [progress.studentId]),
        this.jobApiService.getSuggestions(undefined, [progress.jobId]),
        this.jobApiService.ckeckJobUsers([progress.jobId])
      ).subscribe(([students, jobs, checkedJobs]) => {
        MailSendFlowComponent.instance.config = mailConfigInstance;
        mailConfigInstance.setParams({
          student: students.length ? students[0] : [],
          enterpriseId: progress.enterprise.id,
          jobs: [{ ...jobs[0], jobUsers: checkedJobs[0].jobUsers }],
          ...progressObj
        });
        MailSendFlowComponent.instance.start();
        const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
          this.refreshData(true, true);
          if (progress && this.eventEditors[progress.id]) {
            this.eventEditors[progress.id] = null;
          }
          sentSub.unsubscribe();
        });
        const closedSub = MailSendFlowComponent.instance.closed.subscribe(
          () => {
            sentSub.unsubscribe();
            closedSub.unsubscribe();
          }
        );
      });
    }
  }

  getYearMonthFromDateString(dateString) {
    return this.expectedCompanyYomiService.getYearMonthFromDateString(dateString);
  }
  handleUpdateRaExpectedContractMonth($event, progress) {
    this.expectedCompanyYomiService
      .handleUpdateRaExpectedContractMonth($event.target.value, progress)
      .subscribe((res) => this.progressApiService.refreshEvent.emit());
  }

  private onEditorActionClick(
    progressId: number,
    requestObject: ProgressUpdateWithActionRequest,
    seminarValues: { label: string; value: number }[]
  ): void {
    if (!requestObject) {
      return;
    }

    const progress = this.progresses.find((p) => p.id === progressId);
    this.onSubStatusCancelClick(progress);

    if (seminarValues) {
      this.editorMeta[progressId] = deepClone(this.baseEditorMeta);
      this.editorMeta[
        progressId
      ].groups[0].rows[0].fields.last().options = seminarValues;
    } else {
      this.editorMeta[progressId] = this.baseEditorMeta;
    }

    this.eventEditors[progressId] = {
      seminarAt: this.datePipe.transform(new Date(), "yyyy/MM/dd"),
      seminarType: 1,
      seminarAtMailSendFlag: false,
      requestObject: requestObject,
      inSave: false
    };
  }

  private onOperationActionClick(
    progressId: number,
    requestObject: ProgressUpdateWithActionRequest
  ): void {
    if (!requestObject) {
      return;
    }

    this.progressApiService
      .updateWithAction(progressId, requestObject)
      .subscribe((resp: { id: number }) => {
        // this.refreshData(true, true);
        this.progressApiService.refreshEvent.emit();
      });
  }

  /**
   * 「営業書類結果待ち」への遷移が履歴書未提出により不可かを判定する。
   * mach-api の ProgressService.isRecommendBlockedByResume() と同じ判定にすること。
   * 片方だけ変えると、API は許可するのに画面がボタンを殺す（またはその逆）状態になる。
   */
  private isRecommendBlockedByResume(progress: ProgressItemResponse): boolean {
    const required = progress.job && progress.job.dynamicData ? progress.job.dynamicData.resumeRequiredOnRecommend : null;
    if (!Array.isArray(required) || required.indexOf(RESUME_REQUIRED_ON_RECOMMEND_VALUE) < 0) {
      return false;
    }

    if (!progress.student || !progress.student.dynamicData) {
      return false;
    }

    const status = progress.student.dynamicData.documentSubmissionStatus;

    return status === null || status === undefined || status === '';
  }

  private createResumeRequiredDialogConfig(): ConfirmDialogConfig {
    return {
      title: '推薦OK状態ではありません。',
      messages: ['履歴書が未提出または未確認のため、「営業書類結果待ち」にできません。'],
      buttons: { yes: 'OK', no: '', hideNo: true },
    };
  }

  private openResumeRequiredDialog(): void {
    this.dialog.open(ConfirmDialogComponent, this.createResumeRequiredDialogConfig());
  }

  private onDialogActionClick(
    progress: ProgressItemResponse,
    dialog: Type<any>,
    actionId: number
  ): void {
    if (!dialog) {
      return;
    }

    let dataObj = {};
    if (actionId === 140) {
      this.progressApiService.getContractInfo(progress.id).subscribe(info => {
        if (
          info.approvedContractIds.length &&
          info.enterpriseBillingAddressIds.length
        ) {
          dataObj = {
            progressId: progress.id,
            enterpriseId: progress.enterprise.id,
            progressType: progress.type,
            jobUsers: progress.job.jobUsers,
            caUserId: progress.student.caUserId
          };
          const dRef = this.dialog.open(dialog, { data: dataObj });
          const dCloseSubscription = dRef.afterClosed.subscribe(res => {
            if (res) {
              this.refreshData(true, true);
            }
            dCloseSubscription.unsubscribe();
          });
        } else {
          PopupControlComponent.instance.open({
            title: "必要な情報が入力されていません",
            content:
              "承認済みの契約が登録されていないか、\n請求先が登録されていません。",
            confirmText: "閉じる",
            confirmCallback: () => false
          });
        }
      });
      return;
    } else if (actionId === 74) {
      dataObj = {
        studentIds: [progress.studentId],
        jobId: progress.jobId,
        progressStatus: progress.status,
        progressN: progress.n,
        progressIds: [progress.id],
        progressType: progress.type,
        title:
          dialog === ProgressScheduleAdjustDialogComponent
            ? "求職者へ日程調整送信"
            : null,
        enterpriseId: progress.enterprise.id
      };
    }

    const dialogRef = this.dialog.open(dialog, { data: dataObj });
    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  private onDeleteActionClick(progressId: number): void {
    this.progressApiService
      .delete(progressId)
      .subscribe(() =>
        this.progressApiService.refreshEvent.emit(RefreshEvent.DELETE)
      );
  }

  public onSaveClick(progress: ProgressItemResponse) {
    if (
      this.eventEditors[progress.id] &&
      this.eventEditors[progress.id].inSave
    ) {
      return;
    }

    let eventRequestObject: ProgressUpdateWithActionRequest | null = null;
    let remarksRequestObject: ProgressHistoryRemarksUpdateRequest | null = null;
    let remarksRequest: Observable<{ id: number }> | null = null;
    let eventRequest: Observable<{ id: number }> | null = null;

    if (this.remarkEditors[progress.id]) {
      const remarks = this.remarkEditors[progress.id].remarks || "";
      remarksRequestObject = { remarks: remarks };
      remarksRequest = this.progressApiService.updateHistoryRemarks(
        progress.id,
        progress.latestRevision,
        remarksRequestObject
      );
    }

    if (this.eventEditors[progress.id]) {
      this.eventEditors[progress.id].inSave = true;
      const event = this.eventEditors[progress.id];

      if (event.requestObject && event.seminarAt) {
        const seminarAtStr = new Date(event.seminarAt).toAsialDateTimeString();
        eventRequestObject = {
          ...event.requestObject,
          ...{
            seminarAt: seminarAtStr,
            seminarType: event.seminarType || 1,
            seminarAtMailSendFlag: event.seminarAtMailSendFlag ? 0 : 1
          }
        };
        if (progress.status === 70) {
          if (eventRequestObject.seminarType === 1) {
            eventRequestObject.seminarType = 0;
            eventRequestObject.action = 72;
            eventRequestObject.n = progress.n;
          } else if (
            eventRequestObject.seminarType === 99 ||
            eventRequestObject.seminarType === 100
          ) {
            eventRequestObject.action = 74;
            eventRequestObject.n = (progress.n || 0) + 1;
          }
        }
        const newPhaseName = eventRequestObject.seminarType === 0
          ? 'セミナー'
          : getSeminarTypeLabel('面接', eventRequestObject.seminarType, eventRequestObject.n);
        eventRequest = this.progressApiService.updateWithAction(
          progress.id,
          eventRequestObject
        ).pipe(
          concatMap(() => {
            return this.progressApiService.updateScreeningRequestDeadlines(
              progress.id,
              seminarAtStr
            );
          }),
          concatMap(() => {
            return this.progressApiService.syncMainScreeningRequestType(
              progress.id,
              newPhaseName
            );
          })
        );
        if (remarksRequest) {
          remarksRequest = this.progressApiService.updateHistoryRemarks(
            progress.id,
            (progress.latestRevision || 0) + 1,
            remarksRequestObject
          );
        }
      }

      if (!event.seminarAtMailSendFlag) {
        this.progressApiService.getStakeholders([progress.id]).subscribe(
          (stakeholders: ProgressStakeholderEmailResponse[]) => {
            const stakeholder =
              stakeholders && stakeholders.length ? stakeholders[0] : null;
            if (
              stakeholders &&
              stakeholder.studentInfo.mainAvailable === "不可"
            ) {
              PopupControlComponent.instance.open({
                title: "エラー",
                content: "E-MAIL(メイン)が「送信不可」です。",
                confirmText: "閉じる",
                confirmCallback: () => {
                  this.eventEditors[progress.id].inSave = false;
                }
              });
            } else if (stakeholder) {
              this.mailApiService
                .getMailTemplates()
                .pipe(
                  map((templates: MailTemplateResponse[]) =>
                    templates.find(
                      template =>
                        template.id ===
                        (progress.type === 0
                          ? 14
                          : progress.type === 1
                          ? 19
                          : -1)
                    )
                  )
                )
                .subscribe(
                  (template: MailTemplateResponse) => {
                    if (template) {
                      const mailRequestObject = {
                        to:
                          stakeholder.studentInfo.mainAvailable !== "不可"
                            ? [stakeholder.studentInfo.main]
                            : null,
                        cc: [
                          stakeholder.studentInfo.subAvailable !== "不可"
                            ? stakeholder.studentInfo.sub
                            : null,
                          ...stakeholder.jobUsersInfo
                            .filter(jobUser => jobUser.type === 0)
                            .map(jobUser => jobUser.email)
                        ].filter(v => v),
                        bcc: [
                          ...stakeholder.jobUsersInfo
                            .filter(
                              jobUser =>
                                jobUser.type ===
                                (progress.type === 0
                                  ? EnterpriseDepartmentUserType.RA
                                  : progress.type === 1
                                  ? EnterpriseDepartmentUserType.PA
                                  : -1)
                            )
                            .map(jobUser => jobUser.email)
                        ].filter(v => v),
                        userId: this.authService.loginUser.id,
                        from: this.authService.loginUser.email,
                        subject: template.subject,
                        text: template.body,
                        templateTypeId: 8,
                        jobId: progress.jobId
                      };
                      const mailRequest = this.mailApiService
                        .replaceTemplate(mailRequestObject.templateTypeId, {
                          from: mailRequestObject.from,
                          to: mailRequestObject.to,
                          subject: mailRequestObject.subject,
                          text: mailRequestObject.text,
                          studentId: progress.studentId,
                          jobId: progress.jobId
                        })
                        .pipe(
                          mergeMap(res => {
                            mailRequestObject.subject = res.subject;
                            mailRequestObject.text = res.body;
                            return this.mailApiService.sendStudentMail(
                              progress.studentId,
                              mailRequestObject
                            );
                          })
                        );

                      if (eventRequest && remarksRequest) {
                        eventRequest = eventRequest.pipe(
                          mergeMap(() =>
                            remarksRequest.pipe(mergeMap(() => mailRequest))
                          )
                        );
                      } else if (remarksRequest) {
                        eventRequest = remarksRequest.pipe(
                          mergeMap(() => mailRequest)
                        );
                      } else {
                        eventRequest = eventRequest.pipe(
                          mergeMap(() => mailRequest)
                        );
                      }

                      /* node 22 対応 */
                      this.doMailSubscribe(eventRequest);

                      setTimeout(() => {
                        // this.refreshData(true, true);
                        this.eventEditors[progress.id].inSave = false;
                        this.onCancelClick(progress.id);
                        PopupControlComponent.instance.open({
                          title: "メール送信処理開始",
                          content:
                            "メール送信処理を開始しました。\nしばらく経ってからメール管理画面へ反映されます。\n\nもしメール送信が失敗した場合、メール送信失敗メールが届きます。",
                          confirmText: "OK",
                          confirmCallback: () => false
                        });
                        CacheInterceptor.requestCountChange.emit(0);
                      }, 10);

                      setTimeout(() => {
                        CacheInterceptor.requestCountChange.emit(0);
                      }, 1000);

                      /*
                      eventRequest.subscribe(
                        () => {
                          this.refreshData(true, true);
                          this.eventEditors[progress.id].inSave = false;
                          this.onCancelClick(progress.id);
                        },
                        () => {
                          this.eventEditors[progress.id].inSave = false;
                        },
                      );
                      */
                    } else {
                      this.eventEditors[progress.id].inSave = false;
                    }
                  },
                  () => {
                    this.eventEditors[progress.id].inSave = false;
                  }
                );
            } else {
              this.eventEditors[progress.id].inSave = false;
            }
          },
          () => {
            this.eventEditors[progress.id].inSave = false;
          }
        );
      } else if (eventRequest || remarksRequest) {
        if (eventRequest && remarksRequest) {
          eventRequest = eventRequest.pipe(mergeMap(() => remarksRequest));
        } else if (remarksRequest) {
          eventRequest = remarksRequest;
        }
        eventRequest.subscribe(() => {
          // this.refreshData(true, true);
          this.progressApiService.refreshEvent.emit();
          this.eventEditors[progress.id].inSave = false;
          this.onCancelClick(progress.id);
        });
      } else {
        this.eventEditors[progress.id].inSave = false;
      }
    } else {
      remarksRequest.subscribe(() => {
        this.refreshData(true, true);
        this.onCancelClick(progress.id);
      });
    }
  }

  public doMailSubscribe(doMail: any): void {
    doMail.subscribe();
  }

  public onStopReasonSaveClick(progress: ProgressItemResponse) {
    if (!this.stopReasonEditors[progress.id]) {
      this.onCancelClick(progress.id);
      return;
    }

    const stopReasonText = this.stopReasonEditors[progress.id].stopReason || "";

    this.progressApiService
      .updateWithoutAction(progress.id, {
        type: progress.type,
        hasInterview: progress.hasInterview,
        n: progress.n,
        seminarType: progress.seminarType,
        seminarAt:
          progress.seminarAt != null
            ? new Date(progress.seminarAt).toAsialDateTimeString()
            : null,
        isStudentDelay: progress.isStudentDelay,
        dynamicData: {
          ...progress.dynamicData,
          stopReason: stopReasonText
        }
      })
      .subscribe(
        () => {
          this.refreshData(true, true);
          this.onCancelClick(progress.id);
        },
        (error: HttpErrorResponse) => {
          const dialogConfig: ConfirmDialogConfig = ConfirmDialogConfig.createErrorDialog(
            error
          );
          this.dialog.open(ConfirmDialogComponent, dialogConfig);
        }
      );
  }

  public onCancelClick(progressId: number) {
    if (this.eventEditors[progressId]) {
      delete this.eventEditors[progressId];
    }
    if (this.remarkEditors[progressId]) {
      delete this.remarkEditors[progressId];
    }
    if (this.stopReasonEditors[progressId]) {
      delete this.stopReasonEditors[progressId];
    }
  }

  public editRemarks(progressId: number, remarks: string) {
    this.remarkEditors[progressId] = {
      remarks: remarks,
      edit: true,
      show: true
    };
  }

  public toggleRemarksDisplay(progressId: number) {
    if (!this.remarkEditors[progressId]) {
      this.remarkEditors[progressId] = {
        remarks: "",
        edit: false,
        show: true
      };
      return;
    }
    this.remarkEditors[progressId].show = !this.remarkEditors[progressId].show;
  }

  public editStopReason(progressId: number, stopReason: string) {
    this.stopReasonEditors[progressId] = {
      stopReason: stopReason,
      edit: true,
      show: true
    };
  }

  public toggleStopReasonDisplay(progressId: number) {
    if (!this.stopReasonEditors[progressId]) {
      this.stopReasonEditors[progressId] = {
        stopReason: "",
        edit: false,
        show: true
      };
      return;
    }
    this.stopReasonEditors[progressId].show = !this.stopReasonEditors[
      progressId
    ].show;
  }

  loadProgress = (
    page,
    pageSize,
    sortingField,
    sortingOrder
  ): Observable<BatchResult> => {
    return this.progressApiService
      .getList(
        cleanObject({
          ...this.requestObject,
          status: this.requestObject ? this.requestObject.status || [] : [],
          sort: sortingField,
          order: sortingOrder,
          from: page * pageSize,
          size: pageSize
        })
      )
      .pipe(
        map((resp: ProgressSearchResponse) => {
          this.progresses = (this.progresses || [])
            .concat(resp.progresses)
            .filter((p, i, self) => self.findIndex(x => x.id === p.id) === i);
          return {
            result: resp.progresses,
            totalSize: resp.total ? resp.total : 0
          };
        }),
        catchError((error: HttpErrorResponse) => {
          // ネットワークに繋がらなかったときはエラーを通知する
          this.errorGetList.emit(error);
          return EMPTY;
        })
      );
  };

  private refreshData(dataOnly?: boolean, noScroll?: boolean) {
    this.progresses = [];
    this.table.reset(dataOnly, noScroll);
    this.table.next();
    this.computeCanBulkEdit();
    this.computeCanSeminarScheduleLink();
  }

  public isValidSelectedItemsForBulkScheduleAdjust() {
    const selectedProgresses = this.table && this.table.checkedItems;
    if (!selectedProgresses || !selectedProgresses.length) {
      return false;
    }
    if (
      selectedProgresses.length === 1 &&
      (selectedProgresses[0].status === 70 ||
        selectedProgresses[0].status === 100)
    ) {
      return true;
    }

    const isJobIdSame = selectedProgresses
      .map((progress: ProgressItemResponse) => progress.jobId)
      .every(jobId => jobId === selectedProgresses[0].jobId);
    const isStatusSame = selectedProgresses
      .map((progress: ProgressItemResponse) => progress.status)
      .every(
        status =>
          status === selectedProgresses[0].status &&
          (selectedProgresses[0].status === 70 ||
            selectedProgresses[0].status === 100)
      );
    let isNSame = true;
    if (selectedProgresses[0].status === 100) {
      isNSame = selectedProgresses
        .map((progress: ProgressItemResponse) => progress.n)
        .every(n => n === selectedProgresses[0].n);
    }
    return isJobIdSame && isStatusSame && isNSame;
  }

  public openProgressBulkScheduleAdjustDialog(): void {
    if (!this.isValidSelectedItemsForBulkScheduleAdjust()) {
      return;
    }

    const selectedProgresses: ProgressItemResponse[] =
      this.table && this.table.checkedItems;
    if (!selectedProgresses || !selectedProgresses.length) {
      return;
    }

    const dialogRef = this.dialog.open(ProgressScheduleAdjustDialogComponent, {
      data: {
        studentIds: selectedProgresses.map(progress => progress.studentId),
        jobId: selectedProgresses[0].jobId,
        progressStatus: selectedProgresses[0].status,
        progressN: selectedProgresses[0].n,
        progressSeminarType: selectedProgresses[0].seminarType,
        progressIds: selectedProgresses.map(progress => progress.id),
        progressType: selectedProgresses[0].type,
        enterpriseId: selectedProgresses[0].enterprise.id
      }
    });
    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  public openSeminarScheduleLinkDialog(): void {
    if (!this.canSeminarScheduleLink) {
      return;
    }

    const checkedItems = this.table.checkedItems as ProgressItemResponse[];
    if (!checkedItems || !checkedItems.length) {
      return;
    }

    const matchedScheduleList = this.getMatchedSeminarScheduleList();
    if (!matchedScheduleList || !matchedScheduleList.length) {
      return;
    }

    this.dialog.open(
      ProgressSeminarScheduleLinkDialogComponent,
      {
        data: {
          schedules: matchedScheduleList
        }
      },
      (result: ProgressSeminarScheduleLinkDialogResult) => {
        if (!result || !result.jobSettingSeminarScheduleId) {
          return;
        }
        const progressIds = checkedItems.map(item => item.id);
        return this.progressApiService
          .bulkSeminarSchedule(progressIds, result.jobSettingSeminarScheduleId)
          .pipe(tap(() => this.progressApiService.refreshEvent.emit()));
      }
    );
  }

  public openProgressBulkDeclineDialog(): void {
    if (!this.hasCheckedItems) {
      return;
    }

    const config: ConfirmDialogConfig = {
      title: "一括辞退",
      messages: ["一括辞退をしてもよろしいですか"],
      style: {
        height: "245px",
        width: "600px"
      },
      buttons: {
        no: "キャンセル",
        yes: "OK"
      }
    };
    this.dialog.open(ConfirmDialogComponent, config, (result: boolean) => {
      if (result) {
        return this.progressApiService
          .bulkDecline(
            this.table.checkedItems
              .map(item => (item && item["id"] ? item["id"] : null))
              .filter(v => v != null)
          )
          .pipe(
            tap(() => {
              // this.refreshData(true, true);
              this.progressApiService.refreshEvent.emit();
            })
          );
      }
    });
  }

  public openProgressBulkEditDialog(): void {
    if (!this.checkCanBulkEdit()) {
      return;
    }

    const config: BulkProgressChangeDialogConfig = {
      data: {
        options: deepClone(
          PROGRESS_BULK_EDIT[this.table.checkedItems[0].status]
        )
      }
    };
    this.dialog.open(
      BulkProgressChangeDialogComponent,
      config,
      (result: ProgressBulkEditAction) => {
        if (result) {
          this.openProgressBulkEditConfirmationDialog(result);
        }
      }
    );
  }

  private openProgressBulkEditConfirmationDialog(
    result: ProgressBulkEditAction
  ) {
    const config: ConfirmDialogConfig = {
      title: "一括変更",
      messages: [
        `選択した全ての進捗ステータスを「${result.label(
          undefined,
          1
        )}」へ一括で変更します。よろしいですか？`
      ],
      style: {
        height: "245px",
        width: "600px"
      },
      buttons: {
        no: "キャンセル",
        yes: "OK"
      }
    };
    this.dialog.open(ConfirmDialogComponent, config, (confirmed: boolean) => {
      if (!confirmed) {
        return;
      }

      const progressIds = this.table.checkedItems
        .map(item => (item && item["id"] ? item["id"] : null))
        .filter(v => v != null);
      const request: ProgressBulkEditRequest = {
        toStatus: result.toStatus,
        fromStatus: result.fromStatus,
        stopReason: result.stopReason,
        remarks: result.remarks
      };
      return this.progressApiService.bulkEdit(progressIds, request).pipe(
        tap(() => {
          this.canBulkEdit = false;
          this.refreshData(true, true);
          this.progressApiService.refreshEvent.emit();
        })
      );
    });
  }

  private checkCanBulkEdit(): boolean {
    if (!this.hasCheckedItems) {
      return false;
    }

    const status = this.table.checkedItems[0].status;

    return (
      Object.keys(PROGRESS_BULK_EDIT).includes("" + status) &&
      this.checkedItemsStatusIs(status)
    );
  }

  directTransition(
    progress: ProgressItemResponse,
    transition: ProgressBulkEditAction
  ) {
    const requestDto: ProgressBulkEditRequest = {
      fromStatus: transition.fromStatus,
      toStatus: transition.toStatus,
      remarks: transition.remarks,
      stopReason: transition.stopReason
    };
    const directSubs = this.progressApiService
      .bulkEdit([progress.id], requestDto)
      .subscribe(() => {
        this.refreshData(true, true);
        this.progressApiService.refreshEvent.emit();
        directSubs.unsubscribe();
      });
  }

  private checkRoute() {
    if (this.router.url.endsWith("/progresses/add")) {
      this.openProgressCreateDialog();
    }
  }

  checkedItemsStatusIs(status: number): boolean {
    return this.table
      ? this.table.checkedItems.every(i => i.status === status)
      : false;
  }

  public openProgressCreateDialog(origUrl = this.location.path()): void {
    if (this.dialogRef) {
      return;
    }
    this.location.go("/progresses/add");
    ProgressDetailComponent.instance.close();
    this.dialogRef = this.dialog.open(ProgressCreateDialogComponent, {
      data: {
        studentId: this.student ? this.student.id : null,
        jobId: this.job ? this.job.id : null,
        enterpriseId: this.requestObject
          ? this.requestObject.enterpriseId
          : null
      }
    });
    let closeSubscription: Subscription;
    let navigationSubscription: SubscriptionLike;
    const unsubscribe = () => {
      if (closeSubscription) {
        closeSubscription.unsubscribe();
      }
      if (navigationSubscription) {
        navigationSubscription.unsubscribe();
      }
    };
    closeSubscription = this.dialogRef.afterClosed.subscribe(() => {
      this.location.go(origUrl);
      this.dialogRef = null;
      unsubscribe();
    });
    navigationSubscription = this.location.subscribe(() => {
      this.dialogRef.close();
      unsubscribe();
    });
  }

  openMail(
    config: MailSendConfig,
    progress?: ProgressItemResponse,
    refreshProgressList?: boolean
  ): void {
    const jobIds = [];
    const studentIds = [];
    const enterprises = [];
    const progressIds = [];
    let students = [];
    let jobs = [];
    if (progress) {
      progressIds.push(progress.id);
      jobIds.push(progress.jobId);
      studentIds.push(progress.studentId);
      enterprises.push({
        frontId: progress.enterprise.frontId,
        id: progress.enterprise.id,
        name: progress.enterprise.name
      });
    } else {
      this.table.checkedItems.forEach((item: ProgressItemResponse) => {
        if (!(config instanceof ProgressNgEndConfig) || item.status === 170) {
          progressIds.push(item.id);
          jobIds.push(item.jobId);
          studentIds.push(item.studentId);
          enterprises.push({
            frontId: item.enterprise.frontId,
            id: item.enterprise.id,
            name: item.enterprise.name
          });
        }
      });
    }
    const obs = [];
    if (this.student) {
      students.push({
        id: this.student.id,
        frontId: this.student.frontId,
        emailMain: getValueFromObject(
          this.student.dynamicData,
          "emailMain.email"
        ),
        emailMainAvailable: getValueFromObject(
          this.student.dynamicData,
          "emailMain.emailAvailable"
        ),
        emailSub: getValueFromObject(
          this.student.dynamicData,
          "emailSub.email"
        ),
        emailSubAvailable: getValueFromObject(
          this.student.dynamicData,
          "emailSub.emailAvailable"
        ),
        studentUser: this.student.studentUsers,
        firstName: this.student.dynamicData.firstName,
        lastName: this.student.dynamicData.lastName
      });
    } else {
      obs.push(
        this.studentApiService
          .getSuggestions(undefined, studentIds.removeSame())
          .pipe(tap(res => (students = res)))
      );
    }
    if (this.job && !(config instanceof ProgressRecommendConfig)) {
      jobs.push({
        id: this.job.id,
        frontId: this.job.frontId,
        position: getValueFromObject(this.job.dynamicData, "position"),
        enterpriseName: this.job.enterpriseName,
        enterpriseId: this.job.enterpriseId,
        frontEnterpriseId: this.job.frontEnterpriseId,
        enterpriseDepartmentId: this.job.enterpriseDepartmentId,
        jobUsers: this.job.enterpriseDepartmentUsers
      });
    } else {
      obs.push(
        this.jobApiService
          .getSuggestions(undefined, jobIds.removeSame())
          .pipe(tap(res => (jobs = res)))
      );
    }
    const progressObj: any = {};
    if (progress) {
      if (this.eventEditors[progress.id]) {
        progressObj.progressSeminarAt = new Date(
          this.eventEditors[progress.id].seminarAt
        ).toAsialDateTimeString();
        progressObj.progressSeminarType = this.eventEditors[
          progress.id
        ].seminarType;
      } else {
        progressObj.progressSeminarAt = progress.seminarAt;
        progressObj.progressSeminarType = progress.seminarType;
      }
      progressObj.progressId = progress.id;
      progressObj.progressN = progress.n;
      progressObj.progressHasInterview = progress.hasInterview;
      progressObj.progressSeminarAtMailSendFlag = 1;
      progressObj.progressIsStudentDelay = progress.isStudentDelay;
      progressObj.progressType = progress.type;
      progressObj.progressStatus = progress.status;
    }
    forkJoin(obs).subscribe(() => {
      MailSendFlowComponent.instance.config = config;
      config.setParams({
        progressIds: progressIds,
        students: students,
        jobs: jobs,
        jobId: this.job ? this.job.id : null,
        enterprises: enterprises.removeSame("id"),
        ...progressObj
      });
      MailSendFlowComponent.instance.start();
      if (refreshProgressList) {
        const sentSub = MailSendFlowComponent.instance.sent.subscribe(() => {
          this.refreshData(true, true);
          if (progress && this.eventEditors[progress.id]) {
            this.eventEditors[progress.id] = null;
          }
          sentSub.unsubscribe();
        });
        const closedSub = MailSendFlowComponent.instance.closed.subscribe(
          () => {
            sentSub.unsubscribe();
            closedSub.unsubscribe();
          }
        );
      }
    });
  }

  onStudentLinkClick(event: MouseEvent, studentId: number): void {
    this.onLinkClick(event, StudentDetailPageComponent.instance, studentId);
  }

  onCompanyLinkClick(event: MouseEvent, companyId: number): void {
    this.onLinkClick(event, CompanyDetailPageComponent.instance, companyId);
  }

  onJobLinkClick(event: MouseEvent, jobId: number): void {
    this.onLinkClick(event, JobDetailPageComponent.instance, jobId);
  }

  private onLinkClick(event: MouseEvent, detail: DetailPage, id: number): void {
    event.stopPropagation();
    detail.referenceId = id;
    detail.open();
  }

  private buildConfirmInterviewInfoUpdateRequest(
    progress: ProgressItemResponse,
    progressObj: any
  ): ProgressUpdateWithActionRequest {
    return {
      type: progress.type,
      hasInterview: progress.hasInterview,
      n: progress.n,
      seminarType: progressObj.progressSeminarType,
      seminarAt: progressObj.progressSeminarAt,
      isStudentDelay: progress.isStudentDelay,
      action:
        progress.status === ProgressStatusCode.セミナー確認中
          ? 82
          : 112,
      seminarAtMailSendFlag: 0
    };
  }

  private buildSendInterviewInfoUpdateRequest(
    progress: ProgressItemResponse,
    progressObj: any
  ): ProgressUpdateWithActionRequest {
    const isSettingSeminar =
      progress.status === ProgressStatusCode.セミナー設定中;
    const isSemiOrFinalInterview = [
      SEMINAR_TYPE.SEMI_FINAL_INTERVIEW,
      SEMINAR_TYPE.FINAL_INTERVIEW
    ].includes(progressObj.progressSeminarType);

    return {
      type: progress.type,
      hasInterview: progress.hasInterview,
      n:
        isSettingSeminar && isSemiOrFinalInterview
          ? progress.n + 1
          : progress.n,
      seminarType:
        progressObj.progressSeminarType === SEMINAR_TYPE.INTERVIEW &&
        progressObj.progressStatus === ProgressStatusCode.セミナー設定中
          ? SEMINAR_TYPE.SEMINAR
          : progressObj.progressSeminarType,
      seminarAt: progressObj.progressSeminarAt,
      isStudentDelay: progress.isStudentDelay,
      action:
        isSettingSeminar &&
        progressObj.progressSeminarType === SEMINAR_TYPE.INTERVIEW
          ? PROGRESS_ACTION_CODES.SEND_SEMINAR_INVITATION
          : isSettingSeminar && isSemiOrFinalInterview
          ? PROGRESS_ACTION_CODES.SEND_SEMI_OR_FINAL_SEMINAR_INVITATION
          : progress.status === ProgressStatusCode.面接設定中
          ? PROGRESS_ACTION_CODES.SEND_INTERVIEW_INVITATION
          : null,
      seminarAtMailSendFlag: 0
    };
  }

  private computeCanBulkEdit(): void {
    this.canBulkEdit = this.checkCanBulkEdit();
  }

  /**
   * 進捗サブステータス表示判定
   */
  public needShowProgressSubScreeningStatusLabel(progress: ProgressItemResponse): boolean {
    return this.getFirstProgressSubScreeningStatus(progress) != null;
  }

  public needShowStartSubScreeningButton(progress: ProgressItemResponse): boolean {
    return (
      _.isArray(progress.jobScreeningInfoList) &&
      progress.jobScreeningInfoList.length > 0 &&
      this.getFirstProgressSubScreeningStatus(progress) == null
    );
  }

  public openStartSubScreeningProcessDialog(progress: Progress): void {
    const dialogRef = this.dialog.open(ProgressSubScreeningStartDialogComponent, {
      data: {
        progress: progress
      }
    });

    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res && res.saved) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  public openSendMainScreeningRequestMailDialog(progress: Progress): void {
    const dialogRef = this.dialog.open(ProgressScreeningRequestNotifyDialogComponent, {
      data: { progress: progress }
    });

    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res && res.saved) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  public openSendSubScreeningRequestMailDialog(progress: Progress, subStatus: ProgressSubScreeningStatus): void {
    const dialogRef = this.dialog.open(ProgressSubScreeningRequestNotifyDialogComponent, {
      data: {
        progress: progress,
        progressSubScreeningStatus: subStatus,
        jobScreeningInfo: subStatus.jobScreeningInfo
      }
    });

    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res && res.saved) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  public getCurrentSubScreeningProcessData(progress: ProgressItemResponse) {
    const subStatus = this.getFirstProgressSubScreeningStatus(progress);
    if (!subStatus) {
      return {
        raw: null,
        typeLabel: "",
        statusLabel: "",
        nextActionsGroups: [],
        scheduledAtDisplayValue: "",
      };
    }
    const typeLabel = subStatus.jobScreeningInfo && subStatus.jobScreeningInfo.type;
    const currentStatusCode = subStatus.status;
    const statusLabel = PROGRESS_SUB_SCREENING_STATUS_CODE_LABEL_MAPPING[currentStatusCode] || "";
    const hasRequestsToAnnounce = this.hasProgressSubScreeningRequests(subStatus, subStatus.jobScreeningInfo);

    const adjustSchedule: SubStatusAction = {
      label: `${typeLabel}日程調整`,
      btnColor: `green`,
      onClick: (targetProgress) => {
        this.openSubScreeningScheduleAdjustDialog(targetProgress, subStatus);
      }
    };
    const decideSchedule: SubStatusAction = {
      label: `${typeLabel}日時決定`,
      btnColor: 'blue',
      onClick: (targetProgress) => {
        this.openSubScreeningScheduleEditor(targetProgress);
      }
    };
    const decline: SubStatusAction = {
      label: `${typeLabel}辞退`,
      btnColor: `gray`,
      onClick: (targetProgress) => {
        this.updateProgressSubScreeningStatus(
          targetProgress,
          ProgressSubScreeningStatusCodes.辞退
        );
      },
    };
    const confirmSchedule: SubStatusAction = {
      label: `${typeLabel}確認済み`,
      btnColor: 'blue',
      onClick: (targetProgress) => {
        this.updateProgressSubScreeningStatus(
          targetProgress,
          ProgressSubScreeningStatusCodes.結果待ち
        );
      }
    };
    const complete: SubStatusAction = {
      label: `${typeLabel}完了`,
      btnColor: 'substatus',
      onClick: (targetProgress) => {
        this.updateProgressSubScreeningStatus(
          targetProgress,
          ProgressSubScreeningStatusCodes.完了
        );
      }
    };
    const announceScreeningRequests: SubStatusAction = {
      label: `${typeLabel}対応事項案内`,
      btnColor: 'green',
      onClick: (targetProgress) => {
        this.openSendSubScreeningRequestMailDialog(
          targetProgress,
          subStatus
        );
      }
    };

    const statusNextActionsGroups: Record<number, SubStatusAction[][]> = {
      [ProgressSubScreeningStatusCodes.設定中]: [
        [
          {
            ...adjustSchedule,
            withBorderRight: true,
          },
          decideSchedule,
          decline,
        ],[
          complete,
          ...(hasRequestsToAnnounce ? [
            announceScreeningRequests
          ] : []),
        ]
      ],
      [ProgressSubScreeningStatusCodes.確認中]: [
        [
          confirmSchedule,
          decline,
        ],[
          complete,
          ...(hasRequestsToAnnounce ? [
            announceScreeningRequests
          ] : []),
        ]
      ],
      [ProgressSubScreeningStatusCodes.結果待ち]: [
        [decline],
        [
          complete,
          ...(hasRequestsToAnnounce ? [
            announceScreeningRequests
          ] : [])
        ],
      ],
    };

    const shouldDisplayDate = subStatus.status === ProgressSubScreeningStatusCodes.確認中
      || subStatus.status === ProgressSubScreeningStatusCodes.結果待ち;

    const hasScheduleAt = subStatus.scheduledAt !== undefined
      && subStatus.scheduledAt !== null
      && subStatus.scheduledAt !== '';

    const scheduledAtDisplayValue = (shouldDisplayDate && hasScheduleAt)
      ? this.datePipe.transform(subStatus.scheduledAt, "yyyy/MM/dd (E) HH:mm")
      : '';

    return {
      raw: subStatus,
      typeLabel: typeLabel,
      statusLabel: `${typeLabel}${statusLabel}`,
      nextActionsGroups: statusNextActionsGroups[currentStatusCode] || [],
      scheduledAtDisplayValue
    };
  }

  public hasProgressSubScreeningRequests(subStatus: ProgressSubScreeningStatus, jobScreeningInfo: JobScreeningInfo) {
    if (!subStatus) {
      return false;
    }
    const info = jobScreeningInfo || subStatus.jobScreeningInfo;
    if (!info) {
      return false;
    }
    const hasRequest = (value: any): boolean => {
      if (typeof value === 'string') {
        return value.trim().length > 0;
      }
      return !!value;
    };
    return [info.request1, info.request2, info.request3].some(hasRequest);
  }

  private getFirstProgressSubScreeningStatus(
    progress: ProgressItemResponse
  ): ProgressSubScreeningStatus | null {
    const subStatuses = progress.progressSubScreeningStatuses;
    if (!Array.isArray(subStatuses) || subStatuses.length === 0) {
      return null;
    }
    const firstNotCompleted = subStatuses.find(
      status => status &&
      ![
        ProgressSubScreeningStatusCodes.完了,
        ProgressSubScreeningStatusCodes.辞退,
      ].includes(status.status)
    );
    return firstNotCompleted || null;
  }

  private updateProgressSubScreeningStatus(
    progress: ProgressItemResponse,
    nextStatus: number
  ): void {
    if (!progress || !progress.id) {
      return;
    }
    const subStatus = this.getFirstProgressSubScreeningStatus(progress);
    if (!subStatus || !subStatus.id) {
      return;
    }
    const payload: ProgressSubScreeningStatus = {
      status: nextStatus,
      revision: subStatus.revision,
      mainStatus: progress.status,
      mainN: progress.n,
      jobScreeningInfoId: subStatus.jobScreeningInfoId,
    };
    const updateSubscription = this.progressApiService
      .updateProgressSubScreening(progress.id, subStatus.id, payload)
      .subscribe(() => {
        this.refreshData(true, true);
        this.progressApiService.refreshEvent.emit();
        updateSubscription.unsubscribe();
      });
  }

  private openSubScreeningScheduleAdjustDialog(
    progress: ProgressItemResponse,
    subStatus: ProgressSubScreeningStatus
  ): void {
    if (!progress) {
      return;
    }
    let enterpriseId = (progress as any).enterpriseId;
    if (enterpriseId == null && (progress as any).enterprise) {
      enterpriseId = (progress as any).enterprise.id;
    }
    const dialogRef = this.dialog.open(ProgressSubScreeningScheduleAdjustDialogComponent, {
      data: {
        title: `${subStatus.jobScreeningInfo.type} 日程調整送信`,
        studentIds: [progress.studentId],
        jobId: progress.jobId,
        progressType: progress.type,
        enterpriseId: enterpriseId,
        progress: progress,
        progressSubScreeningStatus: subStatus,
        jobScreeningInfo: subStatus.jobScreeningInfo
      }
    });
    const dialogCloseSubscription = dialogRef.afterClosed.subscribe(res => {
      if (res) {
        this.refreshData(true, true);
      }
      dialogCloseSubscription.unsubscribe();
    });
  }

  /**
   * 対応事項管理が有効な進捗フローであるかを判定する
   * - 以下のいずれかに当てはまる場合は有効
   *   - 管理フラグが有効「1」である
   *   - すでにDBの実レコードが紐付いている
   *   - セミナー設定中(70)〜面接結果待ち(120)の範囲
   */
  private isManagementMode(progress: ProgressItemResponse): boolean {
    if (!progress) {
      return false;
    }

    return (
      (progress.dynamicData && progress.dynamicData['screeningRequestsManagementEnabled'] == 1) ||
      (Array.isArray(progress.progressScreeningRequestStatuses) && progress.progressScreeningRequestStatuses.length > 0) ||
      (progress.status >= 70 && progress.status <= 120)
    );
  }

  public getMainScreeningRequests(progress: ProgressItemResponse): ProgressScreeningRequestStatus[] {
    if (!progress) {
      return [];
    }

    if (this.isManagementMode(progress)) {
      return this.getMainScreeningRequestsFromRequestStatusRecords(
        progress,
        progress.progressScreeningRequestStatuses
      );
    }

    return [];
  }

  private getMainScreeningRequestsFromDynamicData(progress: ProgressItemResponse): ProgressScreeningRequestStatus[] {
    const targetInfo = this.getTargetInfoFromProgress(progress);
    const currentPhase = this.getCurrentMainPhaseName(progress);
    const completed = progress.dynamicData &&
      !!progress.dynamicData['correspondenceState'];

    if(!targetInfo || !currentPhase) {
      return [];
    }
    return this.getMainScreeningRequestsFromRequestStatusRecords(
      progress,
      [
        ...(targetInfo.request1 ? [{
          progressId: progress.id,
          requestStatus: completed
            ? ProgressScreeningRequestStatusRequestStatusEnum.completed
            : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
          requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem1,
          requestType: currentPhase,
          jobScreeningInfo: {
            ...targetInfo,
          }
        }] : []),
        ...(targetInfo.request2 ? [{
          progressId: progress.id,
          requestStatus: completed
            ? ProgressScreeningRequestStatusRequestStatusEnum.completed
            : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
          requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem2,
          requestType: currentPhase,
          jobScreeningInfo: {
            ...targetInfo,
          }
        }] : []),
        ...(targetInfo.request3 ? [{
          progressId: progress.id,
          requestStatus: completed
            ? ProgressScreeningRequestStatusRequestStatusEnum.completed
            : ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet,
          requestNo: ProgressScreeningRequestStatusRequestNoEnum.actionItem3,
          requestType: currentPhase,
          jobScreeningInfo: {
            ...targetInfo,
          }
        }] : []),
      ]
    );
  }

  private getMainScreeningRequestsFromRequestStatusRecords(
    progress: ProgressItemResponse,
    progressScreeningRequestStatuses: ProgressScreeningRequestStatus[]
  ): ProgressScreeningRequestStatus[] {
    const currentPhase = this.getCurrentMainPhaseName(progress);
    if (!currentPhase) {
      return [];
    }
    const statuses = Array.isArray(progressScreeningRequestStatuses)
      ? progressScreeningRequestStatuses
      : [];
    return statuses.filter((s: ProgressScreeningRequestStatus) => {
      return (
        !s.jobScreeningInfoId &&
        s.requestType === currentPhase &&
        (s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notInformedYet ||
          s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet)
      );
    });
  }

  public getSubScreeningRequests(progress: ProgressItemResponse): ProgressScreeningRequestStatus[] {
    if (!progress || !progress.progressScreeningRequestStatuses) {
      return [];
    }

    if (this.isManagementMode(progress)) {
      const activeSubStatus = this.getFirstProgressSubScreeningStatus(progress as any);
      if (!activeSubStatus) {
        return [];
      }

      return progress.progressScreeningRequestStatuses.filter((s: ProgressScreeningRequestStatus) => {
        return (
          s.progressSubScreeningStatusId === activeSubStatus.id &&
          (s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notInformedYet ||
            s.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.notHandledYet)
        );
      });
    } else {
      return [];
    }
  }

  public needShowSendMainScreeningRequestMailButton(progress: ProgressItemResponse, mainRequests: ProgressScreeningRequestStatus[]): boolean {
    if (!progress) {
      return false;
    }

    const status = progress.status;
    const isMainScreeningPhaseStatus =
      status === ProgressStatusCode.セミナー設定中 ||
      status === ProgressStatusCode.セミナー確認中 ||
      status === ProgressStatusCode.セミナー結果待ち ||
      status === ProgressStatusCode.面接設定中 ||
      status === ProgressStatusCode.面接確認中 ||
      status === ProgressStatusCode.面接結果待ち;

    if (!isMainScreeningPhaseStatus) {
      return false;
    }

    const targetInfo = this.getTargetInfoFromProgress(progress);
    if (!targetInfo) {
      return false;
    }

    return !!(targetInfo.request1 || targetInfo.request2 || targetInfo.request3);
  }

  public getMainScreeningRequestTypeLabel(progress: ProgressItemResponse, mainRequests: ProgressScreeningRequestStatus[]): string {
    return this.getCurrentMainPhaseName(progress) || '';
  }

  private getCurrentMainPhaseName(progress: ProgressItemResponse): string | null {
    const status = progress.status;
    if (status >= 70 && status <= 90) {
      return 'セミナー';
    }
    if (status >= 100 && status <= 120) {
      return getSeminarTypeLabel('面接', progress.seminarType, progress.n);
    }
    return null;
  }

  public getRequestContent(progress: ProgressItemResponse, statusItem: ProgressScreeningRequestStatus): string {
    const targetInfo = this.getTargetInfo(progress, statusItem);
    if (!targetInfo) return '-';

    return targetInfo[`request${statusItem.requestNo}`] || '-';
  }

  public getRequestDeadline(progress: ProgressItemResponse, statusItem: ProgressScreeningRequestStatus): string {
    if (statusItem.requestStatus === ProgressScreeningRequestStatusRequestStatusEnum.completed) {
      return '対応済み';
    }

    if (statusItem.requestDeadline) {
      const deadlineMoment = moment(statusItem.requestDeadline).utcOffset(9).startOf('day').locale('ja');
      const today = moment().utcOffset(9).startOf('day');
      const dateStr = deadlineMoment.format("YYYY/MM/DD(ddd)");

      if (deadlineMoment.isBefore(today)) {
        return `${dateStr}まで\n(期限日超過)`;
      } else {
        const remainingDays = this.calcRemainingBusinessDays(deadlineMoment);
        return `${dateStr}まで\n(残り${remainingDays}営業日)`;
      }
    }

    const targetInfo = this.getTargetInfo(progress, statusItem);
    if (!targetInfo) return '-';

    const deadlineValue = targetInfo[`request${statusItem.requestNo}Deadline` || ""];
    const option = SCREENING_INFO_REQUEST_DEADLINE_OPTIONS.find(o => o.value === deadlineValue);
    return option ? option.label : '-';
  }

  private calcRemainingBusinessDays(deadline: moment.Moment): number {
    let count = 0;
    const current = moment().utcOffset(9).startOf("day");
    const target = deadline.clone().startOf("day");
    if (target.isSameOrBefore(current)) {
      return 0;
    }

    const tempDate = current.clone();
    // 今日から期限日までをループ
    while (tempDate.isBefore(target)) {
      tempDate.add(1, "days");
      // 土日(0=日, 6=土)を除外
      if (tempDate.day() !== 0 && tempDate.day() !== 6) {
        count++;
      }
    }
    return count;
  }

  private getTargetInfoFromProgress(progress: ProgressItemResponse): any {
    const job = progress.job;
    if (!job || !job.dynamicData) {
      return null;
    }

    const dynamicData = job.dynamicData;
    let n = progress.n;
    if (n && n > 5) {
      n = 5;
    }

    switch(progress.seminarType) {
      case SEMINAR_TYPE.SEMINAR: //セミナー
        return dynamicData.screeningInfoSeminar;
      case SEMINAR_TYPE.INTERVIEW: //面接
        return dynamicData[`screeningInfo${n}`];
      case SEMINAR_TYPE.SEMI_FINAL_INTERVIEW: //面接
        return dynamicData[`screeningInfo${n}`];
      case SEMINAR_TYPE.FINAL_INTERVIEW: //面接
        return dynamicData[`screeningInfo${n}`];
    }

    return null;
  }

  private getTargetInfo(progress: ProgressItemResponse, statusItem: ProgressScreeningRequestStatus): any {
    if (!statusItem) {
      return null;
    }

    if (statusItem.jobScreeningInfo) {
      return statusItem.jobScreeningInfo;
    }

    const job = progress.job;
    if (!job || !job.dynamicData) {
      return null;
    }

    const type = statusItem.requestType || '';
    const dynamicData = job.dynamicData;

    if (type === 'セミナー') {
      return dynamicData.screeningInfoSeminar;
    } else if (type.includes('面接')) {
      const match = type.match(/(\d+)次/);
      let n = match ? match[1] : progress.n;
      if(Number(n) > 5) {
        n = 5;
      }
      return dynamicData[`screeningInfo${n}`];
    }

    return null;
  }

  public toggleAlertDropdown(progressId: number, type: 'main' | 'sub', event: MouseEvent): void {
    event.stopPropagation();
    const currentKey = `${progressId}_${type}`;
    const otherType = type === 'main' ? 'sub' : 'main';
    const otherKey = `${progressId}_${otherType}`;
    const isOpening = !this.alertDropdownStates[currentKey];
    if (isOpening) {
      this.alertDropdownStates[otherKey] = false;
      this.alertDropdownStates[currentKey] = true;
    } else {
      this.alertDropdownStates[currentKey] = false;
    }
  }

  public onCompleteRequestClick(progress: ProgressItemResponse, requestItem: ProgressScreeningRequestStatus, event: MouseEvent): void {
    event.stopPropagation();
    const config: ConfirmDialogConfig = {
      title: '対応事項完了',
      messages: ['この対応事項を完了にしてもよろしいですか？'],
      buttons: { no: 'キャンセル', yes: '完了' }
    };

    this.dialog.open(ConfirmDialogComponent, config, (result: boolean) => {
      if (result) {
        const payload: ProgressScreeningRequestStatus = {
          ...requestItem,
          requestStatus: ProgressScreeningRequestStatusRequestStatusEnum.completed,
          requestCompletedAt: moment().toDate() as any
        };
        this.progressApiService
          .updateProgressScreeningRequestStatus(requestItem.id, progress.id, payload)
          .subscribe(() => {
            this.progressApiService.refreshEvent.emit();
          });
      }
    });
  }

  public subScreeningDateEditing(progress): boolean {
    if(this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
      return false;
    }
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if (!progressSubScreeningStatus) {
      return false;
    }
    return !!this.subStatusEditorMeta[progressSubScreeningStatus.id] &&
      !!this.subStatusEventEditors[progressSubScreeningStatus.id];
  }
  public subScreeningEditorMeta(progress): FormMeta {
    if(this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
      return null;
    }
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if (!progressSubScreeningStatus) {
      return null;
    }
    return this.subStatusEditorMeta[progressSubScreeningStatus.id];
  }
  public subScreeningEventEditor(progress) {
    if(this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
      return null;
    }
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if (!progressSubScreeningStatus) {
      return null;
    }
    return this.subStatusEventEditors[progressSubScreeningStatus.id];
  }

  private openSubScreeningScheduleEditor(
    progress: ProgressItemResponse,
  ): void {
    if(this.eventEditors[progress.id] && this.editorMeta[progress.id]) {
      this.onCancelClick(progress.id);
      return;
    }
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if (!progressSubScreeningStatus) {
      return;
    }
    this.subStatusEditorMeta[progressSubScreeningStatus.id] = deepClone(this.baseSubStatusEditorMeta);

    this.subStatusEventEditors[progressSubScreeningStatus.id] = {
      scheduledAt: this.datePipe.transform(new Date(), "yyyy/MM/dd"),
      skipSendScheduledAtMail: false,
      inSave: false
    };
  }

  public onSubStatusCancelClick(progress: ProgressItemResponse) {
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if(!progressSubScreeningStatus) return;

    if (this.subStatusEventEditors[progressSubScreeningStatus.id]) {
      delete this.subStatusEventEditors[progressSubScreeningStatus.id];
    }
  }

  public onSubStatusSaveClick(progress: ProgressItemResponse): void {
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if(!progressSubScreeningStatus) return;

    if (
      this.subStatusEventEditors[progressSubScreeningStatus.id] &&
      this.subStatusEventEditors[progressSubScreeningStatus.id].inSave
    ) {
      return;
    }

    let eventRequestObject: ProgressSubScreeningStatusUpdateWithActionRequest | null = null;
    let eventRequest: Observable<{ id: number }> | null = null;
    const requestObject: ProgressSubScreeningStatusUpdateWithActionRequest = {
      updatedStatus: ProgressSubScreeningStatusCodes.確認中,
    };

    if (this.subStatusEventEditors[progressSubScreeningStatus.id]) {
      this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = true;
      const event = this.subStatusEventEditors[progressSubScreeningStatus.id];

      if (event.scheduledAt) {
        const scheduledAtStr = new Date(event.scheduledAt).toAsialDateTimeString();
        eventRequestObject = {
          ...requestObject,
          ...{
            scheduledAt: scheduledAtStr,
            scheduledAtMailSendFlag: event.skipSendScheduledAtMail ? 0 : 1
          }
        };
        eventRequest = this.progressApiService.updateProgressScreeningRequestStatusWithAction(
          progressSubScreeningStatus.progressId,
          progressSubScreeningStatus.id,
          eventRequestObject
        ).pipe(
          concatMap(() => {
            return this.progressApiService.updateSubScreeningRequestDeadlines(
              progressSubScreeningStatus.progressId,
              progressSubScreeningStatus.id,
              scheduledAtStr,
              progressSubScreeningStatus.jobScreeningInfoId
            );
          })
        );
      }

      if (!event.skipSendScheduledAtMail) {
        const scheduledAtReplacementValue = event.scheduledAt
          ? this.datePipe.transform(
              new Date(event.scheduledAt).toAsialDateTimeString(),
              "yyyy年M月d日 HH時mm分"
            )
          : "";
        this.progressApiService.getStakeholders([progressSubScreeningStatus.progressId]).subscribe(
          (stakeholders: ProgressStakeholderEmailResponse[]) => {
            const stakeholder =
              stakeholders && stakeholders.length ? stakeholders[0] : null;
            if (
              stakeholders &&
              stakeholder.studentInfo.mainAvailable === "不可"
            ) {
              PopupControlComponent.instance.open({
                title: "エラー",
                content: "E-MAIL(メイン)が「送信不可」です。",
                confirmText: "閉じる",
                confirmCallback: () => {
                  this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                }
              });
            } else if (stakeholder) {
              this.mailApiService
                .getMailTemplates()
                .pipe(
                  map((templates: MailTemplateResponse[]) =>
                    templates.find(
                      template =>
                        template.systemName === 'student_confirm_sub_screening'
                    )
                  )
                )
                .subscribe(
                  (template: MailTemplateResponse) => {
                    if (template) {
                      const mailRequestObject = {
                        to:
                          stakeholder.studentInfo.mainAvailable !== "不可"
                            ? [stakeholder.studentInfo.main]
                            : null,
                        cc: [
                          stakeholder.studentInfo.subAvailable !== "不可"
                            ? stakeholder.studentInfo.sub
                            : null,
                          ...stakeholder.jobUsersInfo
                            .filter(jobUser => jobUser.type === 0)
                            .map(jobUser => jobUser.email)
                        ].filter(v => v),
                        bcc: [
                          ...stakeholder.jobUsersInfo
                            .filter(
                              jobUser =>
                                jobUser.type ===
                                (progress.type === 0
                                  ? EnterpriseDepartmentUserType.RA
                                  : progress.type === 1
                                  ? EnterpriseDepartmentUserType.PA
                                  : -1)
                            )
                            .map(jobUser => jobUser.email)
                        ].filter(v => v),
                        userId: this.authService.loginUser.id,
                        from: this.authService.loginUser.email,
                        subject: template.subject,
                        text: template.body,
                        templateTypeId: template.mailTemplateTypeId,
                        jobId: progress.jobId
                      };
                      const mailRequest = this.mailApiService
                        .replaceTemplate(mailRequestObject.templateTypeId, {
                          from: mailRequestObject.from,
                          to: mailRequestObject.to,
                          subject: mailRequestObject.subject,
                          text: mailRequestObject.text,
                          studentId: progress.studentId,
                          jobId: progress.jobId,
                          progress,
                          additionalReplacements: [
                            {
                              label: "面接日時",
                              value: scheduledAtReplacementValue,
                            },
                            {
                              label: "サブステータス-選考名",
                              value: String(
                                (progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.type) ||
                                  ""
                              )
                                .replace(/[\r\n]+/g, "")
                                .trim(),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '会場名',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.location
                              ),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '会場住所',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.address
                              ),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '会場最寄駅',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.nearestStation
                              ),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '所要時間',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.duration
                              ),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '持参物',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.preparation
                              ),
                              withoutAppendingNewline: true,
                            },
                            {
                              label: '緊急連絡先',
                              value: formatTemplateMultilineValue(
                                progressSubScreeningStatus &&
                                  progressSubScreeningStatus.jobScreeningInfo &&
                                  progressSubScreeningStatus.jobScreeningInfo.emergencyContact
                              ),
                              withoutAppendingNewline: true,
                            },
                          ],
                        })
                        .pipe(
                          mergeMap(res => {
                            mailRequestObject.subject = res.subject;
                            mailRequestObject.text = res.body;
                            return this.mailApiService.sendStudentMail(
                              progress.studentId,
                              mailRequestObject
                            );
                          })
                        );

                      eventRequest = eventRequest.pipe(
                        mergeMap(() => mailRequest)
                      );

                      /* node 22 対応 */
                      this.doMailSubscribe(eventRequest);

                      setTimeout(() => {
                        this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                        this.onSubStatusCancelClick(progress);
                        PopupControlComponent.instance.open({
                          title: "メール送信処理開始",
                          content:
                            "メール送信処理を開始しました。\nしばらく経ってからメール管理画面へ反映されます。\n\nもしメール送信が失敗した場合、メール送信失敗メールが届きます。",
                          confirmText: "OK",
                          confirmCallback: () => false
                        });
                        CacheInterceptor.requestCountChange.emit(0);
                      }, 10);

                      setTimeout(() => {
                        CacheInterceptor.requestCountChange.emit(0);
                      }, 1000);
                    } else {
                      this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                    }
                  },
                  () => {
                    this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
                  }
                );
            } else {
              this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
            }
          },
          () => {
            this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
          }
        );
      } else if (eventRequest) {
        eventRequest.subscribe(() => {
          this.progressApiService.refreshEvent.emit();
          this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
          this.onSubStatusCancelClick(progress);
        });
      } else {
        this.subStatusEventEditors[progressSubScreeningStatus.id].inSave = false;
      }
    }
  }

  public onSubStatusMailActionClick(
    progress: ProgressItemResponse,
    mailConfig: any
  ): void {
    if (!mailConfig) {
      return;
    }
    const progressSubScreeningStatus: ProgressSubScreeningStatus
       = this.getFirstProgressSubScreeningStatus(progress);
    if(!progressSubScreeningStatus) return;

    const mailConfigInstance = new mailConfig();

    const progressObj: any = {};
    const event = this.subStatusEventEditors[progressSubScreeningStatus.id];
    if (progressSubScreeningStatus) {
      if (event) {
        progressObj.progressScheduledAt = new Date(event.scheduledAt).toAsialDateTimeString();
      }
      progressObj.progress = progress;
      progressObj.progressSubScreeningStatus = progressSubScreeningStatus;
    }

    if (mailConfigInstance instanceof ProgressSendSubScreeningInfoConfig) {
      this.progressApiService
        .getStakeholders([progress.id])
        .subscribe((stakeholders: ProgressStakeholderEmailResponse[]) => {
          if (stakeholders.length) {
            MailSendFlowComponent.instance.config = mailConfigInstance;
            mailConfigInstance.setParams({
              stakeholders: stakeholders[0],
              progressType: progress.type,
              studentId: progress.studentId,
              jobId: progress.jobId,
              enterpriseId: progress.enterprise.id,
              ...progressObj
            });
            MailSendFlowComponent.instance.start({
              additionalReplacements: [
                {
                  label: 'サブステータス-選考名',
                  value: progressSubScreeningStatus.jobScreeningInfo.type,
                  withoutAppendingNewline: true,
                }, {
                  label: '面接日時',
                  value: this.datePipe.transform(
                    new Date(event.scheduledAt).toAsialDateTimeString(),
                    'yyyy年M月d日 HH時mm分'
                  ),
                }
              ]
            });
            if (
              [
                ProgressSubScreeningStatusCodes.設定中,
              ].includes(progressSubScreeningStatus.status)
            ) {
              const scheduledAtStr = new Date(event.scheduledAt).toAsialDateTimeString();
              const sub = MailSendFlowComponent.instance.sent.subscribe(() => {
                this.progressApiService
                  .updateProgressScreeningRequestStatusWithAction(
                    progress.id,
                    progressSubScreeningStatus.id,
                    {
                      updatedStatus: ProgressSubScreeningStatusCodes.確認中,
                      scheduledAt: scheduledAtStr,
                      scheduledAtMailSendFlag: 0,
                    }
                  ).pipe(
                    concatMap(() => this.progressApiService.updateSubScreeningRequestDeadlines(
                      progress.id,
                      progressSubScreeningStatus.id,
                      progressObj.progressScheduledAt
                    ))
                  )
                  .subscribe(() => {
                    this.progressApiService.refreshEvent.emit();
                    if (progress && this.eventEditors[progress.id]) {
                      this.eventEditors[progress.id] = null;
                    }
                  });
                sub.unsubscribe();
              });
              const closedSub = MailSendFlowComponent.instance.closed.subscribe(
                () => {
                  sub.unsubscribe();
                  closedSub.unsubscribe();
                }
              );
            }
          }
        });
    }
  }

  private computeCanSeminarScheduleLink(): void {
    this.canSeminarScheduleLink =
      this.enableSeminarScheduleLinkButton &&
      !!this.getMatchedSeminarScheduleList();
  }

  private getMatchedSeminarScheduleList(): JobSettingSeminarSchedule[] | null {
    if (!this.hasCheckedItems) {
      return null;
    }

    const checkedItems = this.table.checkedItems as ProgressItemResponse[];

    // 既にセミナースケジュール予約済みの進捗は対象外
    if (checkedItems.some(item => item.hasSeminarScheduleReservation)) {
      return null;
    }

    // 紐付け対象は「セミナー確認中 / セミナー結果待ち」のみ許可
    const hasValidStatus = checkedItems.every(
      item =>
        item.status === ProgressStatusCode.セミナー確認中 ||
        item.status === ProgressStatusCode.セミナー結果待ち
    );
    if (!hasValidStatus) {
      return null;
    }

    // 1件選択時: 対象progressのseminarAtに一致するstartAtがschedule上に存在すること
    if (checkedItems.length === 1) {
      const item = checkedItems[0];
      const schedule =
        item &&
        item.job &&
        item.job.jobSettingSeminar &&
        item.job.jobSettingSeminar.schedule;
      if (!schedule || !schedule.length || !item.seminarAt) {
        return null;
      }
      const seminarAt = moment(item.seminarAt);
      const matched = schedule.filter(s => moment(s.startAt).isSame(seminarAt));
      return matched.length ? matched : null;
    }

    // 複数選択時: 同一求人(jobId)のprogressのみ紐付け可能
    const firstJobId = checkedItems[0].jobId;
    if (!checkedItems.every(item => item.jobId === firstJobId)) {
      return null;
    }

    // 複数選択時: seminarAtが全件同一であること
    const firstSeminarAt = checkedItems[0].seminarAt;
    if (!firstSeminarAt) {
      return null;
    }
    const seminarAt = moment(firstSeminarAt);
    if (
      !checkedItems.every(
        item => item.seminarAt && moment(item.seminarAt).isSame(seminarAt)
      )
    ) {
      return null;
    }

    // 同一seminarAtに一致するstartAtが、対象求人のscheduleに存在すること
    const firstItem = checkedItems[0];
    const schedule =
      firstItem &&
      firstItem.job &&
      firstItem.job.jobSettingSeminar &&
      firstItem.job.jobSettingSeminar.schedule;
    if (!schedule || !schedule.length) {
      return null;
    }
    const matched = schedule.filter(s => moment(s.startAt).isSame(seminarAt));
    return matched.length ? matched : null;
  }
}
